import type { ApiInfo } from '@meego-remote/core/app/common';
import type { GwApiService } from '@meego-remote/core/app/service';
import { inject, IGwApiService } from '@meego-remote/core/app/contract';

export abstract class BaseGwApiService {
  @inject(IGwApiService)
  public gwApiService: IGwApiService;

  public registerApiMap(map: Record<string, ApiInfo>) {
    // page_server 环境没有 registerApi，保护一下
    (this.gwApiService as GwApiService).registerApi?.(map);
  }
}
